import type { TeamId } from '../../types/game';
import clsx from 'clsx';
import { Icon } from '../Icon';

interface MegaBuzzerProps {
  status: 'idle' | 'active' | 'winner' | 'blocked' | 'turn';
  team: TeamId;
  onPress: () => void;
}

export const MegaBuzzer = ({ status, onPress }: MegaBuzzerProps) => {
  return (
    <button
      onPointerDown={(e) => {
        e.preventDefault();
        if (status === 'active') onPress();
      }}
      disabled={status === 'idle' || status === 'blocked' || status === 'turn'}
      className={clsx(
        'w-full max-w-[320px] aspect-square md:max-w-[480px] rounded-[3rem]',
        'flex flex-col items-center justify-center gap-6 md:gap-8',
        'transition-all duration-100 select-none ease-out outline-none',
        'border-[6px] touch-manipulation',
        status === 'idle' && 'bg-bg-surface border-white/10 text-white/30 border-4 shadow-none cursor-not-allowed',
        status === 'active' && 'bg-primary border-white text-black cursor-pointer shadow-[16px_16px_0px_white] hover:-translate-y-2 hover:-translate-x-2 hover:shadow-[24px_24px_0px_white] active:translate-x-0 active:translate-y-0 active:shadow-none',
        status === 'winner' && 'bg-warning border-white text-black shadow-[0_0_80px_rgba(152,16,250,0.6)] cursor-not-allowed',
        status === 'blocked' && 'bg-danger border-white/30 text-white/80 opacity-60 shadow-none cursor-not-allowed',
        status === 'turn' && 'bg-success border-white text-black shadow-none cursor-not-allowed',
      )}
    >
      <span className="text-[6rem] md:text-[8rem] leading-none flex drop-shadow-md">
        {status === 'winner' && <Icon name="star" size="7xl" />}
        {status === 'blocked' && <Icon name="lock" size="7xl" />}
        {status === 'active' && <Icon name="bolt" size="7xl" />}
        {status === 'turn' && <Icon name="microphone" size="7xl" />}
        {status === 'idle' && <Icon name="hourglass" size="7xl" />}
      </span>
      <span className="text-3xl md:text-5xl font-black uppercase tracking-wider drop-shadow-sm">
        {status === 'winner' && '¡GANASTE!'}
        {status === 'blocked' && 'NO PUEDES'}
        {status === 'active' && '¡ROBAR!'}
        {status === 'turn' && 'TU TURNO'}
        {status === 'idle' && 'ESPERA'}
      </span>
    </button>
  );
};
